import { render, staticRenderFns } from "./CmgMakeItAFavoriteCard.vue?vue&type=template&id=0dd65da9&scoped=true&lang=pug&"
import script from "./cmg-make-it-a-favorite-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-make-it-a-favorite-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMakeItAFavoriteCard.vue?vue&type=style&index=0&id=0dd65da9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd65da9",
  null
  
)

export default component.exports